import { useEffect, useState, useRef } from "react";

import "./style.scss";
import "./../../public/css/h5vp.css";
import MyPlayer, { extractFileNamesWithoutExtension } from "../public/MyPlayer";
import Overlay from "./Overlay/Overlay";
import PopupOpener from "./PopupOpener/PopupOpener";
import Video from "./Video";
import { isYoutubeURL, useWPAjax } from "../../../wp-utils/v1";
import Youtube from "./Youtube";
import isVimeoLink from "../utils/isVimeoLink";
import EndScreen from "./EndScreen/EndScreen";
import Style from "./Style";
import Vimeo from "./Vimeo";
import generateUniqueID from "../../../wp-utils/v1/generateUniqueId";
// import getFileExtension from "../utils/getFileExtension";
import components from "bp-utils";
// const { Sample } = components;

/**
 *
 * @param {attributes} props
 * @param {nonce} props
 * @returns
 */

const VideoPlayer = ({ attributes, nonce = window.h5vpBlock?.nonce }) => {
  const { additionalCSS, additionalID, source, poster, provider, qualities, captions, options, features, uniqueId, styles } = attributes;
  window.attributes = attributes;
  const { popup, overlay, endScreen, hideYoutubeUI } = features;
  const [player, setPlayer] = useState(null);
  const [open, setOpen] = useState(false);
  const [videoSource, setVideoSource] = useState(provider === "library" ? "self-hosted" : provider);
  const { autoplay, muted, loop } = options;
  const { data: isPremium, isLoading } = useWPAjax("pipe_handler", { nonce });
  const { data: videoId, refetch } = useWPAjax("h5vp_ajax_handler", { nonce, method: "create", model: "Video" }, true);

  useEffect(() => {
    // const video = new GenerateThumbnailFromVideo("https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4");
    // video.addEventListener("ready", function () {
    //   console.log(video.getBlobURL());
    // });
  }, []);

  const playerRef = useRef(null);

  useEffect(() => {
    if (open) {
      player?.player.play();
    } else {
      player?.player.pause();
    }
  }, [open]);

  useEffect(() => {
    playerRef.media = playerRef.current?.querySelector("#player");
  }, [playerRef]);

  //initialize player
  useEffect(() => {
    setTimeout(() => {
      const media = playerRef.current?.querySelector("#player");
      console.log({ media, videoSource });
      if (media) {
        const player = new MyPlayer(media, options, { ...features, qualities, captions });
        setPlayer(player);
      }
    }, 100);

    return () => {
      player?.player?.destroy();
    };
  }, [options, features, qualities, captions, playerRef.current]);

  useEffect(() => {
    if (player && !player?.nonce) {
      console.log(nonce);
      player.setNonce(nonce);
    }
    if (player && !player?.videoId) {
      player.setVideoId(videoId);
    }
  }, [nonce, videoId]);

  useEffect(() => {
    if (player) {
      player.setIsPremium(isPremium);
    }
    if (!isLoading && !isPremium && videoSource !== "self-hosted") {
      player?.destroy();
    }
  }, [isPremium, isLoading, videoSource]);

  useEffect(() => {
    if (!videoSource) {
      if (isYoutubeURL(source)) {
        setVideoSource("youtube");
      } else if (isVimeoLink(source)) {
        setVideoSource("vimeo");
      } else {
        setVideoSource("self-hosted");
      }
    }
  }, [source]);

  useEffect(() => {
    if (source && videoSource) {
      refetch({ src: source, type: videoSource, title: extractFileNamesWithoutExtension(source) });
    }
  }, [source, videoSource]);

  useEffect(() => {
    if (player?.player) {
      player.player.poster = poster;
      player.player.source = source;
    }
  }, [source, poster]);

  return (
    <div ref={playerRef} id={uniqueId} className={`h5vp_player_temp  ${popup.enabled ? "h5vp_popup_enabled" : ""} ${open ? "h5vp_popup_open" : ""}`}>
      <Style styles={styles} uniqueId={uniqueId} />
      {/* <Sample /> */}
      <style>{additionalCSS}</style>

      {isPremium && <PopupOpener setOpen={setOpen} popup={popup} poster={poster} />}

      <div className={`plyr_wrapper ${hideYoutubeUI ? "hideUI" : ""}`} id={additionalID} data-unique-id={generateUniqueID(5)}>
        {/* {isPremium && ( */}
        <>
          {videoSource === "vimeo" && <Vimeo source={isVimeoLink(source)} />}
          {videoSource === "youtube" && <Youtube source={isYoutubeURL(source)} />}
        </>
        {/* )} */}
        {videoSource === "self-hosted" && (
          <Video
            qualities={qualities}
            captions={captions}
            source={source}
            poster={poster}
            autoPlay={autoplay}
            muted={muted}
            loop={loop?.active}
            // src={source}
            preload={options.preload}
            isPremium={isPremium}
            playsInline={options.playsinline}
          />
        )}
        {isPremium && (
          <>
            <EndScreen endScreen={endScreen} player={player} />
            <Overlay {...overlay} player={player?.player} />
          </>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
